var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"return-later-wrapper",staticClass:"return-later-wrapper"},[_c('BaseIcon',{staticClass:"return-later-icon",attrs:{"icon-file":'distribution-noleft',"width":258,"height":258}}),_c('p',[_vm._v(" "+_vm._s(_vm.$t('return_later_for_more_swaps_message'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }